export enum Tristate {
  NORMAL = 0,
  SPINNING = 1,
  FAILURE = 2,
}
